/* eslint-disable @typescript-eslint/ban-ts-comment */
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { flatten } from "flat";
import {
  QueryClient,
  QueryCache,
  MutationCache,
  QueryClientProvider,
} from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import enMessages from "./translations/en.json";
import { SnackbarProvider, SnackbarOrigin } from "notistack";
import { MuiThemeProvider } from "./styles/muiTheme.tsx";
import { GlobalContextProvider } from "./context/GlobalContext";
import { UploadContextProvider } from "./context/UploadContext";
import App from "./App.tsx";
import "./styles/main.css";
import ErrorBoundary from "./components/Common/ErrorBoundary.tsx";


const localeConfig: Record<string, any> = {
  en: enMessages,
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => console.error(`Something went wrong: ${error}`),
  }),
  mutationCache: new MutationCache({
    onError: (error) => console.error(`Something went wrong: ${error}`),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const defaultSnackBarOrigin: SnackbarOrigin = {
  vertical: "top",
  horizontal: "center",
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <BrowserRouter>
      <MuiThemeProvider>
        {/* // Todo: Solve this */}
        {/* Default locale en is being used as a fallback due to missing locale data
      for undefined locale in React-intl */}
        <IntlProvider locale={"en"} messages={flatten(localeConfig.en)}>
          <GlobalContextProvider>
              <QueryClientProvider client={queryClient}>
                {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                <SnackbarProvider
                  maxSnack={3}
                  autoHideDuration={2000}
                  anchorOrigin={defaultSnackBarOrigin}
                >
                  <UploadContextProvider>
                    <App />
                  </UploadContextProvider>
                </SnackbarProvider>
              </QueryClientProvider>
          </GlobalContextProvider>
        </IntlProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
